<template>
  <div class="flex flex-col">
    <div
      class="py-4 px-6 flex items-center justify-between border-b border-slate-400"
    >
      <BlTextSubtitle2 text="Table of contents" class="text-slate-700" />
      <BlIcon
        icon="close"
        class="h-6 w-6"
        clickable
        @clicked="$emit('close')"
      />
    </div>
    <div v-if="!tableOfContents.length" class="pt-4 pb-8 px-6 text-center">
      <BlTextBody2
        v-if="report.status === 'unpublished'"
        text="Add heading to create table of contents."
        class="text-slate-700"
      />
      <BlTextBody2
        v-if="report.status === 'published'"
        text="This report doesn't have a table of contents."
        class="text-slate-700"
      />
    </div>
    <div v-else class="py-4 pl-4 pr-6">
      <div
        v-for="content in tableOfContents"
        :key="content.id"
        class="h-8 w-104 pl-2 flex items-center border-l-2 cursor-pointer truncate"
        :class="{
          'border-transparent': sectionFocusedId !== content.id,
          'bg-slate-200 border-light-purple': sectionFocusedId == content.id
        }"
        @click="$emit('change-focus-id', content.id)"
      >
        <div
          class="h-5 truncate"
          :class="{
            'pl-5': content.kind === 'heading2',
            'pl-10': content.kind === 'heading3'
          }"
        >
          <BlTextBody2
            :text="content.data"
            class="truncate"
            :class="{
              'text-light-purple font-semibold': sectionFocusedId == content.id
            }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import BlTextSubtitle2 from "../../BlTextSubtitle2.vue";
import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlIcon from "../../BlIcon.vue";

export default {
  name: "TableOfContents",
  components: {
    BlTextSubtitle2,
    BlTextSubtitle3,
    BlTextBody2,
    BlIcon
  },
  props: {
    sectionFocusedId: { type: Number }
    // @close
    // @change-focus-id
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["report", "sections"]),
    tableOfContents() {
      const arr = [...this.sections];
      return arr.filter(i => i.kind.includes("heading"));
    }
  },
  watch: {},
  mounted() {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/reports/helper/TableOfContents.vue